import { useInterviewQuestionRoleLevelContentUploadMutation } from 'generated/graphql';
import { useState } from 'react';
import {
  Button,
  FileUploadInput,
  InlineNotification,
  Modal,
  ModalSize,
  NotificationType,
  TNotification,
  useNotification,
} from '@spotted-zebra-uk/ui-components';
import styles from './UploadInterviewQuestionsCSVModal.module.scss';

export type IUploadInterviewQuestionsCSVModal = {
  handleCloseModal: () => void;
};

const UploadInterviewQuestionsCSVModal = ({
  handleCloseModal,
}: IUploadInterviewQuestionsCSVModal) => {
  const [fileUploadValue, setFileUploadValue] = useState<File | null>(null);
  const [errorMessages, setErrorMessages] = useState<string[]>([]);

  const { handleMsgType } = useNotification();

  const [fileUpload, fileUploadResponse] =
    useInterviewQuestionRoleLevelContentUploadMutation({
      context: {
        isUpload: true,
      },
      onError: error => {
        handleMsgType({
          type: TNotification.error,
          message: error?.message,
        });
        setFileUploadValue(null);
      },
      onCompleted: data => {
        if (
          data?.InterviewQuestionRoleLevelContentUpload?.errorMessages?.length
        ) {
          setErrorMessages(
            data.InterviewQuestionRoleLevelContentUpload.errorMessages
          );
        } else {
          handleMsgType({
            type: TNotification.success,
            title: 'Interview questions uploaded successfully.',
          });
          handleCloseModal();
        }
      },
    });

  const handleChangeFile = (file: File | null, id: string) => {
    errorMessages.length && setErrorMessages([]);
    setFileUploadValue(file);
  };

  const handleSubmit = () => {
    if (fileUploadValue) {
      fileUpload({ variables: { file: fileUploadValue } });
    }
  };

  return (
    <Modal
      onClose={handleCloseModal}
      isOpen
      modalSize={ModalSize.SMALL}
      className={styles.container}
      header="Upload CSV to Interview Questions"
    >
      <div className={styles.content}>
        <FileUploadInput
          id="csvFile"
          placeholder="Select file"
          value={fileUploadValue}
          onChange={handleChangeFile}
          acceptedFileTypes={['.csv']}
          className={styles.inputField}
        />
        {Boolean(errorMessages.length) && (
          <InlineNotification
            notificationType={NotificationType.ERROR}
            className={styles.errorNotification}
            children={errorMessages.map((error, index) => (
              <p className={styles.errorItem} key={error}>
                {`${index + 1}. ${error}`}
              </p>
            ))}
          />
        )}
        <div className={styles.buttonContainer}>
          <Button size="medium" onClick={handleCloseModal} variant="secondary">
            Cancel
          </Button>
          <Button
            disabled={!fileUploadValue || fileUploadResponse.loading}
            size="medium"
            onClick={handleSubmit}
          >
            {fileUploadResponse.loading ? 'Validating...' : 'Upload'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default UploadInterviewQuestionsCSVModal;
